import React from 'react';
import loadable from '@loadable/component';
// import { getDiscountList } from '../../../actions/discount';

export default {
	component: loadable(
		() => import(/* webpackChunkName: "discount" */ './OrderReturn'),
		{
			fallback: <div>Loading...</div>
		}
	)
};
